import { Component, Input, OnInit } from '@angular/core';
import { IContentResponse } from '../../../../interfaces/IContentResponse.interface';
import { ICalculatorSection } from '../../../../interfaces/ICalculatorSection.interface';
import { DirectDebitService } from '../../../../services/direct-debit.service';

@Component({
    selector: 'app-calculator-section',
    templateUrl: './calculator-section.component.html',
    styleUrls: ['./calculator-section.component.scss']
})
export class CalculatorSectionComponent implements OnInit {
    @Input() sectionData: ICalculatorSection;
    contents: IContentResponse;

    constructor(private directDebSrv: DirectDebitService) {}

    ngOnInit(): void {
        this.contents = this.directDebSrv.contents$.value;
    }

    sumValueModelChanged(event): void {
        this.sectionData.isActive = true;
        if (event.target.value !== '') {
            this.sectionData.sumValue = parseInt(event.target.value.replace(',', '').replace('₪', ''));
        } else {
            this.sectionData.sumValue = null;
        }
    }
    sumChanged(): void {
        this.sectionData.isActive = this.sectionData.sumValue != null;
    }
    onFocus(): void {
        this.sectionData.isActive = true;
    }
}
